// extracted by css-extract-rspack-plugin
export default {"mobileBreakpoint":"1020px","globalNavHeight":"60px"};